<i18n locale="en">
{
  "no-data": "Design your own text!\n\nhttps://owner.com"
}
</i18n>

<template>
  <div class="flex-col justify-center text-preview">
    <div class="flex-col gap-3 text-preview__bubble">
      <OwnType
        color="primary"
        variant="paragraph-regular"
        :text="content.data?.text || t('no-data')"
        hotlink-urls
        preserve-whitespace
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { OwnType } from '@/ui/OwnType'

interface ContentData {
  text?: string
}

interface Content {
  data?: ContentData
}

defineProps<{
  content: Content
}>()

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.text-preview {
  margin-left: 50px; /* Push the edit button off to the left */

  &__bubble {
    background-color: var(--background-secondary);
    padding: 16px;
    border-radius: 18px;
    width: 220px;
  }
}
</style>
